import { MapPin, Briefcase, ArrowRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const jobs = [
  { title: "Store Manager", dept: "Retail Operations", loc: "Mumbai, MH", type: "Full-time" },
  { title: "Supply Chain Analyst", dept: "Logistics", loc: "Bengaluru, KA", type: "Full-time" },
  { title: "Franchise Development Lead", dept: "Growth", loc: "New Delhi, DL", type: "Full-time" },
  { title: "Category Buyer — Fresh", dept: "Merchandising", loc: "Hyderabad, TS", type: "Full-time" },
  { title: "Cashier / Store Associate", dept: "Retail Operations", loc: "Kolkata, WB", type: "Part-time" },
  { title: "Digital Marketing Executive", dept: "Marketing", loc: "Remote", type: "Full-time" },
];

export default function Careers() {
  return (
    <div>
      <section className="bg-yellow-400 text-slate-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 py-16">
          <span className="text-xs font-semibold uppercase tracking-wider text-slate-800">Careers</span>
          <h1 className="font-heading text-4xl lg:text-5xl font-extrabold mt-2">Grow your career with us</h1>
          <p className="mt-4 text-slate-800 text-lg max-w-xl">Join a fast-moving retail network that invests in its people. Find your next role below.</p>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-4 sm:px-8 py-14 space-y-4">
        {jobs.map((j, i) => (
          <div key={i} data-testid={`job-${i}`} className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 rounded-2xl border border-slate-200/80 dark:border-slate-800 p-6 bg-white dark:bg-slate-900 hover:shadow-lg transition-all">
            <div>
              <h3 className="font-heading font-semibold text-lg">{j.title}</h3>
              <div className="flex flex-wrap gap-3 mt-2 text-sm text-muted-foreground">
                <span className="flex items-center gap-1"><Briefcase className="w-4 h-4" /> {j.dept}</span>
                <span className="flex items-center gap-1"><MapPin className="w-4 h-4" /> {j.loc}</span>
                <Badge variant="secondary">{j.type}</Badge>
              </div>
            </div>
            <Button asChild variant="outline" className="border-yellow-500 text-yellow-700 hover:bg-yellow-100">
              <Link to="/contact">Apply <ArrowRight className="w-4 h-4 ml-1" /></Link>
            </Button>
          </div>
        ))}
      </section>
    </div>
  );
}
